import React from 'react';
import { EnumServiceCategory } from '@quality24/inpatient-typings';
import { Heading, Text } from '@quality24/design-system';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import OrderButton from '@/inpatient-patient-pwa/organisms/OrderButton';
import { ComposedPatientCallReason } from '@/inpatient-patient-pwa/pages/OrderTriggerPage/types';
import useCustomData from '../../../hooks/useCustomData';

export interface Props {
  className?: string;
  reasons: Array<ComposedPatientCallReason>;
  category: EnumServiceCategory;
  /** Overrides the default "Solicitar {category}" heading (e.g. group name). */
  title?: string;
  /** Forwarded to each OrderButton — called after a successful order. */
  onTriggered?: () => void;
}

const PatientCallSection: React.FunctionComponent<Props> = ({
  className,
  reasons,
  category,
  title,
  onTriggered,
}) => {
  const { t } = useTranslation();
  const { infrastructureCalls } = useCustomData();

  const cls = classNames('patient-call-section', className);

  const categoryLabel =
    category === 'ASSISTANCE'
      ? t('order.category.nursing')
      : infrastructureCalls.toLocaleLowerCase();

  const heading =
    title ?? t('order.section.request', { category: categoryLabel });

  return (
    <div className={cls}>
      {reasons.length > 0 && (
        <>
          <Heading as="h4" className="mb-2" size="lg1" weight="semiBold">
            {heading}
          </Heading>
          <Text className="mb-2">{t('order.section.selectOptionToOpen')}</Text>

          <div className="row g-2">
            {reasons.map((reason) => (
              <div key={reason.id} className="col-6 col-sm-4 col-lg-3">
                <OrderButton
                  variant="card"
                  reason={reason}
                  label={reason.reasonI18N || ''}
                  icon={reason.icons?.pwa ?? ''}
                  onTriggered={onTriggered}
                />
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default PatientCallSection;
